// // Safe file operations with comprehensive null checking

// export const safeAccess = (obj, path, defaultValue = null) => {
//   try {
//     if (!obj || typeof obj !== 'object') return defaultValue

//     const keys = path.split('.')
//     let current = obj

//     for (const key of keys) {
//       if (
//         current === null ||
//         current === undefined ||
//         !current.hasOwnProperty(key)
//       ) {
//         return defaultValue
//       }
//       current = current[key]
//     }

//     return current !== null && current !== undefined ? current : defaultValue
//   } catch (error) {
//     console.warn(`Safe access error for path ${path}:`, error)
//     return defaultValue
//   }
// }

export const isValidFileObject = (file) => {
  try {
    return !!(
      file &&
      typeof file === 'object' &&
      file.name &&
      typeof file.name === 'string' &&
      file.name.trim().length > 0
    )
  } catch (error) {
    console.warn('File validation error:', error)
    return false
  }
}

export const sanitizeFileObject = (file) => {
  const previewUrl =
    file.file_url ||
    file.temp_link ||
    file.preview_url ||
    file.dropbox_temp_link

  const dropbox_path = file.dropbox_path

  if (!previewUrl) {
    alert('No preview link found for this file')
    return
  }

  try {
    if (!isValidFileObject(file)) {
      return null
    }

    return {
      // id: safeAccess(file, 'id', Date.now() + Math.random()),
      // name: safeAccess(file, 'name', 'Unknown File'),
      // size: safeAccess(file, 'size', 'Unknown size'),
      // uploadDate: safeAccess(
      //   file,
      //   'uploadDate',
      //   new Date().toISOString().split('T')[0]
      // ),
      // type: safeAccess(file, 'type', 'application/octet-stream'),
      // previewLink: safeAccess(file, 'file_url ', null) || previewUrl,
      // file: safeAccess(file, 'file', null),
      // icon: safeAccess(file, 'icon', '📎'),

      id: file.id,
      name: file.file_name,
      previewLink: previewUrl,
      // type: detectedType,
      size: file.file_size_formatted || file.size,
      uploadDate: file.created_at?.slice?.(0, 10) || file.uploadDate,
      dropbox_path: dropbox_path,
      // icon: safeAccess(file, 'icon', '📎'),
    }
  } catch (error) {
    console.error('Error sanitizing file object:', error)
    return null
  }
}

export const getFileTypeFromName = (fileName) => {
  try {
    if (!fileName || typeof fileName !== 'string') return 'unknown'

    const extension = fileName.split('.').pop()?.toLowerCase() || ''

    const typeMap = {
      image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'],
      pdf: ['pdf'],
      document: ['doc', 'docx'],
      spreadsheet: ['xls', 'xlsx', 'csv'],
      presentation: ['ppt', 'pptx'],
      text: ['txt', 'md'],
      video: ['mp4', 'avi', 'mov', 'wmv', 'webm'],
      audio: ['mp3', 'wav', 'ogg', 'aac'],
    }

    for (const [type, extensions] of Object.entries(typeMap)) {
      if (extensions.includes(extension)) {
        return type
      }
    }

    return 'unknown'
  } catch (error) {
    console.warn('Error determining file type:', error)
    return 'unknown'
  }
}
